import AlertBox from '../../../../components/AlertBox';
import r from '../../../../services/Replacement';

interface Props {
    onDismiss: () => void;
}

export default function MeetingActionSpark({ onDismiss }: Props) {
    return (
        <AlertBox
            colour="BLUE"
            title="Whoop, your first Action item 🎉"
            calloutPosition="BOTTOM_LEFT"
            compact={false}
            onDismiss={onDismiss}
        >
            Unchecked action items will appear in future {r('meeting.name.short.plural.low')} so you can follow up on
            them.
        </AlertBox>
    );
}
